import {
  Box,
  Table as CTable,
  Tbody,
  Thead,
  Th,
  Td,
  Tr,
} from '@chakra-ui/react';

export const Table = ({ table = {} }) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    table;
  return (
    <Box
      className="data-table"
      maxHeight="335px"
      minH="100px"
      overflow="auto"
      borderWidth="1px"
      borderColor="#ebebec"
      borderRadius="8px"
    >
      <CTable {...getTableProps()}>
        <Thead bg="#fff">
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return (
                  <Th {...column.getHeaderProps()}>
                    {column.render('Header')}
                  </Th>
                );
              })}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows?.length === 0 && (
            <Box
              textAlign="center"
              paddingTop="16px"
              color="rgba(22, 22, 22, 0.50)"
              fontSize="14px"
            >
              No contact found
            </Box>
          )}
          {rows?.length > 0 &&
            rows.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()}>
                  {row.cells.map((cell, i) => {
                    return (
                      <Td
                        data-row={i}
                        {...cell.getCellProps()}
                        bg={i === 1 ? '#FCFCFC' : '#FFF'}
                      >
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
        </Tbody>
      </CTable>
    </Box>
  );
};
